<template>
  <div class="mt-5 text-center p-2">
    <p :style="{ fontSize: valueSize }" class="text-primary font-semibold">
      {{ value }}
    </p>
    <hr>
    <p :style="{ fontSize: labelSize }">{{ label }}</p>
  </div>
</template>
<script>
export default {
  name: "MyComponent",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    labelSize: {
      type: String,
      default: "16px",
    },
    valueSize: {
      type: String,
      default: "20px",
    },
  },
};
</script>
